import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import JoditEditor from "jodit-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import backRed from "../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../components/Modal/SucessModal";
import "./JobPostForm.scss";

const JobPostForm = ({ edit = false }) => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const { id } = useParams();
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [about, setAbout] = useState("");
  const [requirements, setRequirements] = useState("");
  const navigate = useNavigate();
  const [department, setDepartment] = useState([]);
  const [position, setPosition] = useState([]);
  const [success, setSuccess] = useState(false);
  const [active, setActive] = useState(null);
  const [uploadImage, setUploadImage] = useState("");
  const [checked, setChecked] = useState(true);

  const handleUpdateData = async () => {
    const fields = await getValues();

    // Validate required rich text fields manually
    if (!fields.requirements || !fields.about || !fields.job_Description) {
      alert(
        "Please fill out all required fields (About, Requirements, Job Description)."
      );
      return;
    }

    const jobPostImageInput = document.getElementById("job_post_image");
    fields["job_post_image"] = jobPostImageInput?.files?.[0]
      ? jobPostImageInput.files[0]
      : fields.job_post_image;

    // fields["active"] = active;
    fields["active"] = fields.status === "Active";

    const formData = new FormData();

    // Append all form values
    Object.keys(fields).forEach((key) => {
      formData.append(key, fields[key]);
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}career-add-job-post/update/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data?._id) {
        setSuccess(true);
      } else {
        alert("Update failed.");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("An error occurred during submission.");
    }
  };

  useEffect(() => {
    handleDepartment();
    handlePosition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDepartment = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}career-add-department/getData`)
      .then((res) => {
        setDepartment(res.data);
      });
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}career-add-department/getData`)
      .then((res) => {
        setDepartment(res.data);
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}career-add-position/getData`)
      .then((res) => {
        setPosition(res.data);
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    id &&
      axios
        .get(`${process.env.REACT_APP_API_URL}career-add-job-post/get/${id}`)
        .then((res) => {
          setActive(res.data.active);
          Object.keys(res.data).forEach((key) => {
            setValue(key, res.data[key] || "");
          });
          setUploadImage(res.data.job_post_image);
        })
        .catch((err) => {
          console.error("Error fetching job post data:", err);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue]);

  const handlePosition = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}career-add-position/getData`)
      .then((res) => {
        setPosition(res.data);
      });
  };

  const onSubmit = (fields) => {
    delete fields.job_post_image;
    fields["job_post_image"] =
      document.getElementById("job_post_image").files[0];
    axios
      .postForm(
        `${process.env.REACT_APP_API_URL}career-add-job-post/create`,
        fields
      )
      .then((response) => {
        if (response.data?._id) {
          setSuccess(true);
        } else {
          console.log("failed...");
        }
      });
  };

  const chooseFile = document.getElementById("job_post_image");
  const imgPreview = document.getElementById("img-preview");
  const handlegetImgdata = async () => {
    const files = await chooseFile?.files[0];
    if (files) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(files);
      fileReader.addEventListener("load", function () {
        imgPreview.style.display = "block";
        imgPreview.innerHTML = '<img src="' + this.result + '" />';
      });
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Careers", link: "/careers" },
      { text: edit ? "Edit Job Post" : "Add New Job Post", link: "" },
    ],
    [edit]
  );

  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <Home> */}
      <div
        onClick={() => navigate("/careerjobpost")}
        className="rose back-button"
      >
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <div className="healtharticle jobPostFormWrapper">
        <div className="healtharticle-container">
          <form
            className="career-jobpost-form"
            onSubmit={handleSubmit(edit ? handleUpdateData : onSubmit)}
          >
            <div className="row">
              <div className="select-department col-5">
                <label className="mb-2 car-text">
                  Select Department / Function Name{" "}
                  <span className="star">*</span>
                </label>
                <div className="Department-Select">
                  <select
                    {...register("department", { required: false })}
                    className="form-select"
                    defaultValue=""
                  >
                    <option selected hidden>
                      Select
                    </option>
                    {department.map((el, index) => {
                      return (
                        <option
                          key={el.id || index}
                          value={el.department}
                          selected={
                            el.department === getValues("department")
                              ? true
                              : false
                          }
                        >
                          {el.department}
                        </option>
                      );
                    })}
                  </select>
                  {errors.department && (
                    <div className={`invalid-feedback d-block`}>
                      Please Select department
                    </div>
                  )}
                </div>
              </div>
              <div className="col-5">
                <label className="car-text mb-2 ">
                  Job Location <span>*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  {...register("job_Location", { required: true })}
                  placeholder="Type here"
                />
                {errors.job_Location && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide a Job Location
                  </div>
                )}
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-4">
                <label className="mb-3 car-text">
                  Type of Job <span>*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  {...register("type_of_job", { required: true })}
                />
                {errors.type_of_job && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide a Type of Job
                  </div>
                )}
              </div>
              <div className="col-2">
                <label style={{ fontSize: "12px" }} className="mb-3  car-text">
                  Total Open Positions <span>*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  {...register("total_Open_Position", { required: true })}
                />
                {errors.total_Open_Position && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide a Total Open Positions
                  </div>
                )}
              </div>
              <div className="col-6">
                <label className="mb-3  car-text" style={{ fontSize: "12px" }}>
                  Select Position / Designation <span>*</span>
                </label>
                <div className="Select-Position">
                  <select
                    {...register("designation", { required: false })}
                    className="form-select w-75"
                    defaultValue=""
                    // value={designation}
                  >
                    <option value="">Select</option>
                    {position.map((el, index) => {
                      return (
                        <option
                          key={el.id || index}
                          value={el.functionName2}
                          selected={
                            el.functionName2 === getValues("designation")
                              ? true
                              : false
                          }
                        >
                          {el.functionName2}
                        </option>
                      );
                    })}
                  </select>
                  {errors.designation && (
                    <div className={`invalid-feedback d-block`}>
                      Please Select Designation
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-4 ">
              <div className="col-3 upload-img">
                <label className="mb-3  car-text">
                  Upload Image For Job Post
                </label>
                {uploadImage && uploadImage.length > 0 ? (
                  <img
                    src={
                      process.env.REACT_APP_API_URL + "images/" + uploadImage
                    }
                    style={{
                      width: "200px",
                      height: "50px",
                      marginTop: "2%",
                      marginBottom: "5%",
                      display: uploadImage === "" ? "none" : "block",
                    }}
                    alt=""
                  />
                ) : null}
                <div
                  id="img-preview"
                  style={{
                    width: "200px",
                    height: "50px",
                    marginTop: "2%",
                    marginBottom: "5%",
                  }}
                ></div>
                <input
                  className="form-control-file custom-file-input"
                  type="file"
                  id="job_post_image"
                  {...register("job_post_image", { required: false })}
                  onChange={() => {
                    handlegetImgdata();
                  }}
                />
                {errors.job_post_image && (
                  <div className={`invalid-feedback d-block`}>
                    Please Select Job Post Image
                  </div>
                )}
              </div>
            </div>
            <div className="job-description row">
              <div className="col">
                <label className="mb-3 mt-3 car-text">
                  About <span>*</span>
                </label>
                <JoditEditor
                  ref={editor}
                  id="about"
                  value={getValues("about") || ""}
                  onChange={(newContent) => {
                    setAbout(newContent);
                    setValue("about", newContent, { shouldValidate: true });
                  }}
                />
                {!about.length && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide About
                  </div>
                )}
              </div>
            </div>
            <div className="job-description row">
              <div className="col">
                <label className="mb-3 mt-3 car-text">
                  Responsibilities <span>*</span>
                </label>
                <JoditEditor
                  id="job_Description"
                  ref={editor}
                  value={getValues("job_Description") || ""}
                  onChange={(newContent) => {
                    setValue("job_Description", newContent);
                    setContent(newContent); // update local state for validation
                  }}
                />
                {!content?.length && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide Job Description
                  </div>
                )}
              </div>
            </div>
            <div className="job-description row">
              <div className="col">
                <label className="mb-3 mt-3 car-text">
                  Requirements & Skill <span>*</span>
                </label>
                <JoditEditor
                  ref={editor}
                  value={getValues("requirements") || ""}
                  id="requirements"
                  onChange={(newContent) => {
                    setValue("requirements", newContent);
                    setRequirements(newContent); // update local state for validation
                  }}
                />
                {!requirements.length && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide Requirements
                  </div>
                )}
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-3 me-2">
                <label className="mb-2 car-text">
                  Organisation Name <span>*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  {...register("organisation_Name", { required: true })}
                />
                {errors.organization_name && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide Organisation Name
                  </div>
                )}
              </div>
              <div className="col-3 me-2">
                <label className="mb-2 car-text">
                  Employment Start Date <span>*</span>
                </label>
                <input
                  className="form-control"
                  type="date"
                  {...register("employment_Startdate", { required: true })}
                />
                {errors.employment_Startdate && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide Employment Start Date
                  </div>
                )}
              </div>

              <div className="col-2 me-2 form-date">
                <label className="mb-2 car-text">
                  Total Working Days <span>*</span>
                </label>
                <input
                  className="form-control form-date"
                  placeholder="Type"
                  type="text"
                  {...register("total_working_days", { required: true })}
                />
                {errors.total_working_day && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide Total Working Days
                  </div>
                )}
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-3 me-3">
                <label className="mb-3 car-text">
                  {" "}
                  Job Post Expiry <span>*</span>{" "}
                </label>
                <input
                  className="form-control form-date"
                  placeholder="dd-mm-yy"
                  type="date"
                  {...register("jobpost_expiry", { required: true })}
                />
                {errors.jobpost_expiry && (
                  <div className={`invalid-feedback d-block`}>
                    Please provide Job Post Expiry
                  </div>
                )}
              </div>

              <div className="col ">
                <label className="car-text">
                  Status <span>*</span>
                </label>
                <div className="d-flex mt-3">
                  <div className="form-check form-check-inline">
                    {/* <input
                      className="form-check-input me-3"
                      type="radio"
                      value="Active"
                      checked={checked ? "checked" : ""}
                      onClick={() => setChecked(true)}
                      {...register("status", { required: true })}
                    /> */}
                    <input
                      type="radio"
                      value="Active"
                      {...register("status")}
                    />

                    <label for="option-1" className="mt-1">
                      Active
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    {/* <input
                      className="form-check-input me-3"
                      type="radio"
                      value="Inactive"
                      checked={checked ? "" : "checked"}
                      onClick={() => setChecked(false)}
                      {...register("status", { required: true })}
                    /> */}
                    <input
                      type="radio"
                      value="Inactive"
                      {...register("status")}
                    />
                    <label for="option-2" className="mt-1">
                      Inactive
                    </label>
                  </div>
                </div>
                {errors.status && (
                  <div className={`invalid-feedback d-block`}>
                    Please Select an Option
                  </div>
                )}
              </div>
            </div>

            <div className="car-job-button">
              <button type="submit">SUBMIT</button>
            </div>
          </form>
        </div>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal page={"/careerjobpost"} name="new job" post="posted" />
      )}
    </>
  );
};

export default JobPostForm;
